export class FeatureFlag {
  constructor({ name, isActive }: { name: string; isActive: boolean }) {
    this.name = name;
    this.isActive = isActive;
  }

  readonly name: string;
  readonly isActive: boolean;
}
